import React from "react";
import { TextInput, Loading, useNotify } from "react-admin";
import { useEmailForUser, useIdforUser, useSelectedMentees } from "../hooks";
import { Form } from "react-final-form";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import CircularProgress from "@material-ui/core/CircularProgress";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { createMuiTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles({
  chip: {
    color: "#fff",
    marginLeft: ".3rem",
    marginRight: ".3rem",
  },
  chipSm: {
    color: "#fff",
    margin: ".3rem ",
  },
});

const mentorTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#EF8354",
    },
  },
});

export const MenteeDetails = ({ uid }) => {
  const classes = useStyle();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));

  const [mentees, setMentees] = React.useState([]);
  const { selectedMentees } = useSelectedMentees();
  const notify = useNotify();
  let usr = useIdforUser(uid);
 

  React.useEffect(() => {
    if (usr.loaded) {
      setMentees([
        {
          mandatory: true,
          name: usr.data.email_,
          id: usr.data.id,
          key: usr.data.id,
          type: "CREATOR",
          mobileNo: usr.data.mobileNo,
        },
      ]);
    }
  }, [usr]);

  selectedMentees(mentees);

  let email = "";
  const { getEmail } = useEmailForUser(email);

  const handleDelete = (chipToDelete) => {
    let arr = [];
    for (let i = 0; i < mentees.length; i++) {
      if (chipToDelete.name !== mentees[i].name) arr.push(mentees[i]);
    }
    setMentees(arr);
    selectedMentees(arr);
  };

  const handleSubmit = async (values) => {
    const usr = await getEmail(values.email);
    if (usr.length === 1) {
      /* check if already exists */
      for (let i = 0; i < mentees.length; i++) {
        if (mentees[i].name === values.email) {
          notify("User Already added");
          values.email = "";
          return;
        }
      }

      if (mentees.length === 10) {
        notify("Max 10 users can be added");
        values.email = "";
        return;
      }

      let arr = [...mentees];
      arr.push({
        name: values.email,
        id: usr[0].id,
        key: usr[0].id,
        type: "INVITEE",
      });
      setMentees(arr);
      selectedMentees(arr);
      values.email = "";
    } else notify("No such user found!");
    values.email = "";
  };

  return (
    <React.Fragment>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, form, submitting, pristine, values }) => {
          return !usr.loaded ? (
            <Loading />
          ) : (
            <form onSubmit={handleSubmit}>
              <Grid container direction="row" spacing={1} alignItems="center">
                <Grid item style={{ marginBottom: "20px" }}>
                  <TextInput
                    label="Add Mentee"
                    variant="standard"
                    source="email"
                  />
                </Grid>
                <Grid item>
                  <Button
                    color="primary"
                    size="small"
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={submitting}
                  >
                    {submitting ? <CircularProgress size="2rem" /> : "ADD"}
                  </Button>
                </Grid>
              </Grid>
            </form>
          );
        }}
      />

      <Paper elevation={0}>
        {mentees.map((m) => {
          return (
            <Chip
              color="primary"
              label={m.name}
              key={m.id}
              className={isDesktop ? classes.chip : classes.chipSm}
              onDelete={!m.mandatory ? () => handleDelete(m) : null}
              deleteIcon={<HighlightOffIcon style={{ color: "#fff" }} />}
            />
          );
        })}
      </Paper>
    </React.Fragment>
  );
};
